import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../_config';
import {map} from "rxjs/operators";
import {BehaviorSubject, Observable, of} from 'rxjs'
import {Config} from "../_models/config";

@Injectable({providedIn: 'root'})
export class ConfigService {
  public customerGroupChanged: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public stockChanged: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(private http: HttpClient) {
  }

  private _isLoadingConfig: boolean = false;
  private _lastConfig = {
    instanceName: 'Backoffice',
    customerGroups: [],
    stocks: [],
    customerFields: [],
    paymentMeans: [],
    shopId: null,
    themeNo: 1,
  } as Config;
  private _configSubject: BehaviorSubject<Config> = new BehaviorSubject<Config>(this._lastConfig);
  private _config: Config = null;

  private _customerGroup?: string = null;
  private _stock?: number = null;

  getLastConfig(): Config {
    return this._lastConfig;
  }

  setCustomerGroup(customerGroup: string) {
    if (customerGroup !== this._customerGroup) {
      this._customerGroup = customerGroup;
      this.customerGroupChanged.next(this._customerGroup);
    }
  }

  getCustomerGroup(): string {
    return this._customerGroup;
  }

  setStock(stock: number) {
    if (stock !== this._stock) {
      this._stock = stock;
      this.stockChanged.next(this._stock);
    }
  }
  
  getStock(): number {
    return this._stock;
  }

  getConfig(): Observable<Config> {
    if (this._config) {
      return of(this._config);
    }

    if (this._isLoadingConfig) {
      return this._configSubject;
    }

    this._isLoadingConfig = true;
    return this.http.get<Config>(AppConfig.API_ENDPOINT + `/config`)
      .pipe(
        map(value => {
          this._config = value;
          this._lastConfig = value;
          this._isLoadingConfig = false;

          this._configSubject.next(value);

          return value;
        })
    );
  }
}
